module.exports = __webpack_public_path__ + "img/icon_map_1_5_yj_c.cdfe666a.png";